import { uuidModule } from "@/modules/uuid";
import { BaseSyncOperation } from "@/store/sync/operations/BaseSyncOperation";
import { SyncErrorHandlingType } from "@/store/sync/operations/errors/SyncError";
import { IDeleteAudioRecordingOperation } from "@/store/sync/operations/types";
import {
  OptimisticSyncUpdate,
  SyncCustomErrorData,
  SyncModelData,
  SyncOperationKind,
  SyncUpdatePartialValue,
} from "@/store/sync/types";
import { AudioRecordingModelData } from "@/store/audio-recordings/types";

export class DeleteAudioRecordingOperation extends BaseSyncOperation<IDeleteAudioRecordingOperation> {
  get operationKind(): SyncOperationKind {
    return "DELETE_AUDIO_RECORDING";
  }

  public async generateOptimisticUpdates(): Promise<OptimisticSyncUpdate<SyncModelData>[]> {
    const recording = this.store.audioRecordings.get(this.payload.id);
    if (!recording) return [];

    const value: SyncUpdatePartialValue = {
      model_id: this.payload.id,
      model_kind: "AUDIO_RECORDING",
      model_version: recording.modelVersion,
    };

    const optimisticUpdate: OptimisticSyncUpdate<AudioRecordingModelData> = {
      optimistic_update_id: uuidModule.generate(),
      locally_committed_at: this.committedAt,
      kind: "DELETED",
      value,
    };

    return [optimisticUpdate];
  }

  async triggerRecompute() {
    await this.store.audioRecordings.recompute(this.payload.id);
  }

  handleInvalidError(_errorData: SyncCustomErrorData) {
    this.ignoreError();
  }

  handlePermissionDeniedError(_errorData: SyncCustomErrorData) {
    this.ignoreError();
  }

  handleUnknownError(_errorData: SyncCustomErrorData) {
    this.ignoreError(SyncErrorHandlingType.RetryWithLimit);
  }
}
